import React from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useI18nContext } from '@procore/core-react';
import { useStyles } from './BusinessProfileActivity.styles';
import { Metrics } from '../../types/metrics-types';
import ActivityTile from './ActivityTile';

interface Props {
  metrics: Metrics;
}

const FreeActivityCard = ({ metrics }: Props) => {
  const I18n = useI18nContext();
  const classes = useStyles();
  const displayFirstGrid =
    metrics?.freemiumTotalProjects > 0 || metrics?.freemiumAvgProjectSize > 0;
  const displaySecondGrid =
    metrics?.freemiumNumOfEmployees > 0 ||
    metrics?.freemiumTotalActiveProjects > 0;
  const smMatches = useMediaQuery('(min-width:630px)');

  return (
    <Box>
      {displayFirstGrid && (
        <div style={{ marginBottom: '12px' }}>
          <Grid
            container
            direction={smMatches ? 'row' : 'column'}
            gap={smMatches ? 6 : 0}
          >
            {metrics?.freemiumTotalProjects > 0 && (
              <Grid item>
                <ActivityTile
                  metric={metrics?.freemiumTotalProjects}
                  text={I18n.t(
                    `components.metrics.total_procore_projects_${
                      metrics?.freemiumTotalProjects === 1
                        ? 'singular'
                        : 'plural'
                    }`
                  )}
                />
              </Grid>
            )}
            {metrics?.freemiumAvgProjectSize > 0 && (
              <Grid item>
                <ActivityTile
                  metric={metrics?.freemiumAvgProjectSize}
                  text={I18n.t('components.metrics.freemium_avg_project_size')}
                  isMoney
                />
              </Grid>
            )}
          </Grid>
        </div>
      )}
      {displaySecondGrid && (
        <div>
          <Typography className={classes.title}>
            {I18n.t('components.metrics.current_activity')}
          </Typography>

          <Grid
            container
            direction={smMatches ? 'row' : 'column'}
            spacing={smMatches ? 6 : 0}
          >
            {metrics?.freemiumTotalActiveProjects > 0 && (
              <Grid item>
                <ActivityTile
                  metric={metrics?.freemiumTotalActiveProjects}
                  text={I18n.t(
                    `components.metrics.active_projects_${
                      metrics?.freemiumTotalActiveProjects === 1
                        ? 'singular'
                        : 'plural'
                    }`
                  )}
                />
              </Grid>
            )}
            {metrics?.freemiumNumOfEmployees > 0 && (
              <Grid item>
                <ActivityTile
                  metric={metrics?.freemiumNumOfEmployees}
                  text={I18n.t(
                    `components.metrics.freemium_num_of_employees_${
                      metrics?.freemiumNumOfEmployees === 1
                        ? 'singular'
                        : 'plural'
                    }`
                  )}
                />
              </Grid>
            )}
          </Grid>
        </div>
      )}
    </Box>
  );
};

export default FreeActivityCard;
